import { PrismicLink, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.ArticleCtaSlice} ArticleCtaSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ArticleCtaSlice>} ArticleCtaProps
 * @param {ArticleCtaProps}
 */
const ArticleCta = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className={`bg-${slice.primary.bg_color} mx-4 md:mx-7 lg:mx-0 article-cta px-10 py-30px rounded-[22px] mb-10 md:mb-[60px]`}>
        <div className="mb-5">
          <PrismicRichText field={slice.primary.text} />
        </div>
        <div className="text-center">
          <div className="button button-rounded button-text overflow-hidden background-slide-white">
            <PrismicLink field={slice.primary.cta_page} className="cta_form">
              {slice.primary.cta_label}</PrismicLink>
          </div>
        </div>
      </div>
    </section >
  );
};

export default ArticleCta;
